/**
 * Launches the PCI Pal payment session in a new tab by submitting a form with
 * the bearer and refresh tokens. PCI Pal requires this so the iFrame/browser
 * displays the payment session correctly.
 * @see https://pcipal.stoplight.io/docs/PCIPALAPIGuide/7b45e7f63c161-displaying-the-session
 */
export const launchPciPalSession = ({
  url,
  accessToken,
  refreshToken,
}: {
  url?: string
  accessToken?: string
  refreshToken?: string
}): void => {
  if (
    typeof url !== 'string' ||
    typeof accessToken !== 'string' ||
    typeof refreshToken !== 'string'
  ) {
    throw new Error(
      'PCI PAL failed to connect. Please ensure you are logged in to Backstage with the same email address as the one used on 8x8.'
    )
  }
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = url
  form.target = '_blank'
  form.rel = 'noopener noreferrer'

  const bearerInput = document.createElement('input')
  bearerInput.type = 'hidden'
  bearerInput.name = 'x-bearer-token'
  bearerInput.value = accessToken
  form.appendChild(bearerInput)

  const refreshInput = document.createElement('input')
  refreshInput.type = 'hidden'
  refreshInput.name = 'x-refresh-token'
  refreshInput.value = refreshToken
  form.appendChild(refreshInput)

  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}
